import React, {
  PropsWithChildren,
  ReactElement,
  useRef,
  useState,
} from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Lightbulb01, Lightbulb02, XClose } from "@untitled-ui/icons-react";
import styles from "./videoOverlayTrigger.module.scss";
import { Button, CloseButton, Text } from "@kunduz/ui-atoms";
import { gray } from "../../theme";
import classNames from "classnames";

export const VideoOverlayTrigger = (props: Props): ReactElement => {
  const [inverted, setInverted] = useState(false);
  const videoRef = useRef<HTMLVideoElement>();

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild onClick={props.onClick}>
        {props.triggerNode}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>
          <video
            className={classNames(styles.video, {
              [styles.inverted]: inverted,
            })}
            autoPlay
            controls
            ref={videoRef}
          >
            <source src={props.mediaFile} type="video/mp4" />
          </video>

          <Dialog.Close asChild>
            <CloseButton
              size="md"
              color="gray"
              theme="light"
              className={styles.close}
            >
              <XClose color={gray[200]} />
            </CloseButton>
          </Dialog.Close>
          {props.showInvertButton && (
            <CloseButton
              size="md"
              theme={"light"}
              color="gray"
              onClick={() => setInverted(!inverted)}
              className={styles.invertButton}
            >
              {inverted ? (
                <Lightbulb01 color={gray[200]} />
              ) : (
                <Lightbulb02 color={gray[200]} />
              )}
            </CloseButton>
          )}
          {props.showSkipToAnswerButton !== undefined && (
            <Button
              variant="secondary"
              color="gray"
              size="md"
              className={styles.skipToAnswerButton}
              onClick={() => {
                videoRef.current.pause();
                videoRef.current.currentTime = videoRef.current.duration - 1;
              }}
            >
              <Text variant="textsm" weight="medium">
                {props.showSkipToAnswerButton}
              </Text>
            </Button>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

interface Props {
  triggerNode: JSX.Element;
  mediaFile: string;
  onClick?: () => void;
  showInvertButton?: boolean;
  showSkipToAnswerButton?: string;
}
